// Components
import { Link } from '@tracklib/kit'

import styles from './modalheader.css'

export const HelpText = ({ linkUrl, text }: { linkUrl: string; text?: string }) => {
  return (
    <Link href={linkUrl} target="_blank" className={styles.help} datatesting="register_new_song_support">
      {text || 'Learn more on the support page'}
    </Link>
  )
}
type ModalHeaderProps = {
  title: string | JSX.Element
  description?: string | JSX.Element
  help?: string
}

const ModalHeader = ({ title, description, help }: ModalHeaderProps): JSX.Element => (
  <div className={styles.wrapper}>
    <h1 className={styles.title}>{title}</h1>
    {description && <div className={styles.description}>{description}</div>}
    {help && <HelpText linkUrl={help} />}
  </div>
)

export default ModalHeader
